import { ArticleList } from './ArticleList';
import styles from './KnowledgeScreen.module.css';

/**
 * The knowledge-base screen (M-12, Task 4) — `/knowledge-base`, reachable
 * for a session holding `knowledge.view` (`App.tsx`'s own
 * `rendersKnowledgeBase`, gated through `src/lib/permissions/knowledge.ts`'s
 * `canReadKnowledge`; `navigation.ts`'s pre-existing `knowledgeBase` entry —
 * one of the nine Phase 1 items that has pointed nowhere until now).
 *
 * A thin wrapper, the `RequestScreen.tsx`/`CaseScreen.tsx` shape: this
 * module owns the page container so a later addition has somewhere to
 * mount beside the list without `ArticleList` itself needing to know about
 * it. Spec §3 names no detail route for this module (unlike Cases/
 * Justifications) — expanding a row in the list is the whole of what a
 * reader needs, so there is no second surface for this screen to hold.
 */

export interface KnowledgeScreenProps {
  permissions: readonly string[];
}

export function KnowledgeScreen({ permissions }: KnowledgeScreenProps) {
  return (
    <div className={styles['page']}>
      <ArticleList permissions={permissions} />
    </div>
  );
}
